export default __webpack_public_path__ + "static/media/3_Nebelfront.c3d7c519.png";